import { useEffect, useState } from 'react';
import { caisseAPI } from '../../services/api';

// Mirrored in backend TransactionServiceImpl.validateRequiredRefs — keep both in sync
export const MOBILE_REFS_CATEGORIES = ['Règlement chèque', 'Règlement relevé FA', 'Règlement relevé MF'];
export const VERIF_BC_CORRECTION_CATEGORIES = ['Autres augmente', 'Autres diminue'];
export const VERIFICATION_CAISSE_NAME = 'Vérification';

// MOBILE caisse + règlement category → code client + BC required
export const isMobileRefsCategory = (caisseType, categoryLabel) =>
  caisseType === 'MOBILE' && MOBILE_REFS_CATEGORIES.includes(categoryLabel || '');

// Vérification caisse + (mobile caisse name or Autres augmente/diminue) category → BC required
export const isVerifBcCategory = (caisseName, categoryLabel, mobileCaisseNames = []) =>
  caisseName === VERIFICATION_CAISSE_NAME && (
    mobileCaisseNames.includes(categoryLabel || '') ||
    VERIF_BC_CORRECTION_CATEGORIES.includes(categoryLabel || '')
  );

// Names of MOBILE caisses — only fetched when the caisse is Vérification
export const useMobileCaisseNames = (caisseName) => {
  const [names, setNames] = useState([]);
  useEffect(() => {
    if (caisseName !== VERIFICATION_CAISSE_NAME) { setNames([]); return; }
    caisseAPI.getForFilters().then(res => {
      setNames((Array.isArray(res.data) ? res.data : [])
        .filter(c => c.type === 'MOBILE')
        .map(c => c.name));
    }).catch(() => setNames([]));
  }, [caisseName]);
  return names;
};

// Which refs a given transaction must carry
export const getRequiredRefs = (transaction, mobileCaisseNames = []) => {
  const label = transaction?.category?.label;
  const mobileRefs = isMobileRefsCategory(transaction?.caisse?.type, label);
  const verifBc = isVerifBcCategory(transaction?.caisse?.name, label, mobileCaisseNames);
  return { codeClient: mobileRefs, bc: mobileRefs || verifBc };
};
